export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.13-1537.46",
  commitId: "ce09fd8fd3dcb2a5985cbf046aa6c62d5250b0f5",
  commitTime: "2026-08-13T15:37:46.000Z",
});
